// extracted by mini-css-extract-plugin
export default {"container":"Qu-z","title":"Ru-z","linkContainer":"Su-z","viewItemLink":"Tu-z"};